import React from 'react';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import { CheckboxSimple } from '..//index.js';
import { FILTER_ICONS } from './icons.js';
const PADDING = 6;
export const DropDownMenuItem = (props) => {
    const wrapperRef = React.useRef(null);
    const labelRef = React.useRef(null);
    const [isHovered, setIsHovered] = React.useState(false);
    const icon = typeof props.icon === 'string' ? FILTER_ICONS[props.icon] : props.icon;
    // The checkbox is the item's own accessible control: it is focusable and
    // toggles on space. Items without one act as buttons instead.
    const asButton = !props.checkbox;
    const disabled = props.disabled ?? false;
    const onClick = disabled ? undefined : props.onClick;
    return (React.createElement(Wrapper, { onClick: onClick, onKeyDown: (e) => {
            if (onClick && asButton && (e.key === 'Enter' || e.key === ' ')) {
                e.preventDefault();
                onClick();
            }
        }, ref: wrapperRef, role: asButton ? 'button' : undefined, tabIndex: asButton && !disabled ? 0 : undefined, "aria-disabled": disabled || undefined, $indent: props.indent, $emphasized: props.emphasized, $disabled: disabled, onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false) },
        props.checkbox && (React.createElement(CheckboxSimple, { checked: props.checkbox.checked, indeterminate: props.checkbox.indeterminate, disabled: disabled, ariaLabel: props.label, onChange: props.checkbox.onChange, onClick: (e) => e.stopPropagation(), style: {
                padding: PADDING,
                paddingRight: PADDING * 2,
            } })),
        icon && (React.createElement("div", { style: {
                paddingTop: PADDING,
                paddingBottom: PADDING,
                paddingLeft: props.checkbox ? 0 : PADDING,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            } }, icon)),
        React.createElement(DropdownItemText, { ref: labelRef, style: {
                padding: PADDING,
                paddingLeft: props.checkbox && !icon ? 0 : PADDING,
            } }, props.label),
        props.count !== undefined && React.createElement(Count, null, props.count),
        isHovered &&
            labelRef.current &&
            labelRef.current.scrollWidth >
                labelRef.current.getBoundingClientRect().width + PADDING && (React.createElement(EllipsisTooltip, { style: {
                left: (wrapperRef.current?.getBoundingClientRect().width || 0) +
                    PADDING * 2,
                top: (wrapperRef.current?.offsetTop || 0) -
                    (wrapperRef.current?.parentElement?.scrollTop || 0),
            } }, props.label))));
};
const Wrapper = styled.div `
  transition: background-color 50ms ease-in-out;

  display: flex;
  align-items: center;
  border-radius: 4px;
  cursor: ${(p) => (p.$disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(p) => (p.$disabled ? 0.5 : 1)};
  padding-left: ${(p) => (p.$indent ? PADDING * 3 : 0)}px;
  font-weight: ${(p) => (p.$emphasized ? 600 : 'inherit')};

  &:hover {
    background-color: ${(p) => p.$disabled
    ? 'transparent'
    : `color-mix(in hsl, ${THEME.COLOR_GREY}, transparent 80%)`};
  }
`;
const DropdownItemText = styled.div `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 300px;
`;
const Count = styled.span `
  margin-left: auto;
  padding-left: ${PADDING}px;
  font-size: 11px;
  font-weight: normal;
  color: ${THEME.DARK_COLOR_SECONDARY};
`;
const EllipsisTooltip = styled.div `
  position: absolute;
  background-color: ${THEME.COLOR_SECONDARY};
  border-radius: 4px;
  padding: ${PADDING}px;
  max-width: 500px;
  min-width: 200px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
`;
//# sourceMappingURL=DropDownMenuItem.js.map